export default __webpack_public_path__ + "static/media/homebg.18ecca32.png";